import { render, staticRenderFns } from "./DeviceShareInfoDialog.vue?vue&type=template&id=2b8164a2&scoped=true"
import script from "./DeviceShareInfoDialog.vue?vue&type=script&lang=ts"
export * from "./DeviceShareInfoDialog.vue?vue&type=script&lang=ts"
import style0 from "./DeviceShareInfoDialog.vue?vue&type=style&index=0&id=2b8164a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8164a2",
  null
  
)

export default component.exports